import React from "react";
import "./CustomInput.scss";
import { Input, InputProps } from "antd";

export const CustomInput: React.FC<InputProps> = ({ className, ...rest }) => {
  return <Input className={`custom-input ${className ?? ""}`} {...rest} />;
};
